import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { formatQueryParam, formatQueryParamDate } from 'src/app/utils/query-params.utils';

@Injectable({
  providedIn: 'root'
})
export class DevolucoesService {

  constructor(private readonly http: HttpClient) { }

  getAllDevolucoes(idEmpresaLogada: string, pagina: number, tamanho: string, usuario: any, numeroPedido: string, dataEmissao: any, situacao: string) {
    const emissao = formatQueryParamDate(dataEmissao, 'dataEmissao');
    const codSituacao = formatQueryParam(situacao, 'codigoTipoDevolucao');
    const idPedido = formatQueryParam(numeroPedido, 'idPedido');
    const idUsuario = formatQueryParam(usuario, 'idUsuario');
    const url = `/apiconnect/importation/devolution?idEmpresa=${idEmpresaLogada}&pagina=${pagina}&tamanho=${tamanho}${emissao}${codSituacao}${idPedido}${idUsuario}`;
    return this.http.get(url);
  }

  getUsuarios(idPedido: string, campoUsuario: string) {
    return this.http.get(`/apiconnect/importation/users/${idPedido}/companies/${campoUsuario}/field-values`);
  }

  downloadRelatorioCompleto(idEmpresaLogada: string, usuario: any, numeroPedido: string, dataEmissao: any, situacao: string) {
    const emissao = formatQueryParamDate(dataEmissao, 'emissionDate');
    const codSituacao = formatQueryParam(situacao, 'devolutionTypeCode');
    const idPedido = formatQueryParam(numeroPedido, 'orderId');
    const idUsuario = formatQueryParam(usuario, 'userId');
    return this.http.get(
      `/apiconnect/importation/devolution-csv?companyId=${idEmpresaLogada}${emissao}${codSituacao}${idPedido}${idUsuario}`,
      { observe: 'response', responseType: 'blob' as 'json' }
    );
  }
}
